<h2 mat-dialog-title>This will incur a charge. Please confirm your order.</h2>
<mat-dialog-content class="mat-typography">
  <p>
    Please note that ordering a kit to be sent to the patient's home address
    will incur a charge that will be billed to the clinician.
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>OK</button>
  <button mat-button [mat-dialog-close]="false">Cancel</button>
</mat-dialog-actions>
